// components
import SvgIconStyle from 'src/components/SvgIconStyle';
// icons
import { AiTwotoneSetting } from 'react-icons/ai';
import { BsTelephone, BsVoicemail } from 'react-icons/bs';

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: getIcon('ic_dashboard'),
  callHistory: <BsTelephone />,
  voicemail: <BsVoicemail />,
  voicemailSettings: <AiTwotoneSetting />,
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Features',
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: ICONS.dashboard },
      { title: 'Call History', path: '/dashboard/call-history', icon: ICONS.callHistory },
      { title: 'Voicemail', path: '/dashboard/voicemail', icon: ICONS.voicemail },
      {
        title: 'Voicemail Settings',
        path: '/dashboard/voicemail-settings',
        icon: ICONS.voicemailSettings,
      },
    ],
  },
];

export default navConfig;
